module.exports = __webpack_public_path__ + "media/images/front/about/thumbnail5-8bcf6ed41707d7bf6224ee49b4704e6e.jpg";